<tec-modal
	[isVisible]="true"
	[title]="title"
    [buttonPrimaryLabel]="buttonPrimaryLabel"
    [buttonSecondaryLabel]="'BUTTON.CANCEL' | translate"
	(closeEvent)="closeModal($event)">
	<ng-container body [formGroup]="form">
        <tec-stepper-micro [steps]="steps" (clickEvent)="clickStep($event)"></tec-stepper-micro>
        @if (errorMsg) {
            <tec-alert
                status="error"
                [msg]="errorMsg"
                (closeAlert)="errorMsg = ''"
            ></tec-alert>
        }
        @if (steps.length && steps.at(0)?.selected) {
            @if (docsFiltered.length) {
                <div class="item-group" style="height: 30dvh; overflow: auto; padding: 1px;">
                    @for (doc of docsFiltered; track $index) {
                        <tec-item [title]="doc.title"
                            [tagImage]="{icon: doc.icon, status: 'control'}"
                            [selected]="form.get('type').value === doc.type"
                            (click)="selectDoc(doc)">
                            <tec-list-detail>
                                <span>{{ doc.description }}</span>
                            </tec-list-detail>
                        </tec-item>
                    }
                </div>
            } @else {
                <tec-empty-state
                    [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.NOT_RESULT' | translate"
                    [size]="'default'"
                    [type]="'notresults'"
                ></tec-empty-state>
            }
        }
        @if (steps.length && steps.at(1)?.selected) {
            <!-- <h5>{{ form.get('docInfo')?.value?.title }}</h5> -->
            <tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.CONFIG' | translate" icon="icon-capture-popup">
                <!-- SOLO CONNECTION -->
                @if (form.get('docInfo').value?.confRecommended?.connection_available) {
                    <div class="grid grid-i2">
                        <tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.GET_METHOD' | translate"
                            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.AUTO_TOOLTIP' | translate">
                            {{ 'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.AUTO' | translate }}
                        </tec-form-group>
                        <tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.MANDATORY' | translate">
                            <tec-switch [value]="true" [disabled]="true"></tec-switch>
                        </tec-form-group>
                    </div>
                    <tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FALLBACK' | translate"
                        [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.MANUAL_TOOLTIP' | translate">
                        {{ 'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.ATTACH' | translate }}
                    </tec-form-group>
                } @else {
                    <div class="grid grid-i2">
                        <tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.GET_METHOD' | translate"
                            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.MANUAL_TOOLTIP' | translate">
                            {{ 'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.MANUAL' | translate }}
                        </tec-form-group>
                        <tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.MANDATORY' | translate">
                            <tec-switch formControlName="required"></tec-switch>
                        </tec-form-group>
                        <tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.CAPTURE_TYPE' | translate"
                            [errorMsg]="reactiveFormService.hasMsgError(form.get(`method`))">
                            <tec-toggle
                                [options]="methodOptions"
                                formControlName="method"
                                requireSelection
                            ></tec-toggle>
                        </tec-form-group>
                    </div>
                    <!-- <div class="grid">
                        @if (form.get('type').value !== 'GENERIC') {
                            <tec-divider style="padding-bottom: 24px;"></tec-divider>
                            <tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.DEMAND_LEVEL' | translate">
                                <tec-toggle
                                    [options]="[
                                        {
                                            id: 'recommended',
                                            label: 'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.RECOMMENDED' | translate
                                        },
                                        {
                                            id: 'custom',
                                            label: 'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.CUSTOM' | translate
                                        },
                                    ]"
                                    formControlName="demand_level"
                                    [multiple]="false"
                                    requireSelection
                                ></tec-toggle>
                            </tec-form-group>
                        }
                    </div> -->
                    <!-- NIF-993: Nº intentos para todos los tipos no-conexión; min/max/cotejo solo GENERIC -->
                    @if (form.get('type').value === 'GENERIC') {
                    <tec-tile [subtitle]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.GENERIC_CUSTOM_SUBTITLE' | translate">
                        <div class="grid grid-i3">
                                <tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.NUM_TRIED' | translate"
                                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.NUM_TRIED_TOOLTIP' | translate"
                                    [errorMsg]="reactiveFormService.hasMsgError(form.get('total_tries'))">
                                    <tec-input-quantity
                                        [min]="1"
                                        [max]="5"
                                        [step]="1"
                                        formControlName="total_tries"
                                        [hasError]="reactiveFormService.hasError(form.get('total_tries'))"
                                    ></tec-input-quantity>
                                </tec-form-group>
                                <tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.NUM_MIN_DOC' | translate"
                                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.NUM_MIN_DOC_TOOLTIP' | translate"
                                    [errorMsg]="reactiveFormService.hasMsgError(form.get('min'))">
                                    <tec-input-quantity
                                        [min]="1"
                                        [max]="5"
                                        [step]="1"
                                        formControlName="min"
                                        [hasError]="reactiveFormService.hasError(form.get('min'))"
                                    ></tec-input-quantity>
                                </tec-form-group>
                                <tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.NUM_MAX_DOC' | translate"
                                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.NUM_MAX_DOC_TOOLTIP' | translate"
                                    [errorMsg]="reactiveFormService.hasMsgError(form.get('max'))">
                                    <tec-input-quantity
                                        [min]="1"
                                        [max]="20"
                                        [step]="1"
                                        formControlName="max"
                                        [hasError]="reactiveFormService.hasError(form.get('max'))"
                                    ></tec-input-quantity>
                                </tec-form-group>
                                <tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.COMPARE_DATA' | translate"
                                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.COMPARE_DATA_TOOLTIP' | translate">
                                    <tec-switch formControlName="match_data"></tec-switch>
                                </tec-form-group>
                            </div>
                        </tec-tile>
                    } @else {
                        <tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.NUM_TRIED' | translate"
                            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.NUM_TRIED_TOOLTIP' | translate"
                            [errorMsg]="reactiveFormService.hasMsgError(form.get('total_tries'))">
                            <tec-input-quantity
                                [min]="1"
                                [max]="5"
                                [step]="1"
                                formControlName="total_tries"
                                [hasError]="reactiveFormService.hasError(form.get('total_tries'))"
                            ></tec-input-quantity>
                        </tec-form-group>
                    }
                }
            </tec-tile>
        }
        @if (steps.length && steps.at(2)?.selected) {
            <tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.INSTRUCTIONS' | translate" icon="icon-AI">
                <tec-tabs [tabs]="docLocaleTabs" (tabSelected)="onDocLocaleTabSelected($event)" />
                <div id="modal-doc-locale-field-title" class="modal-doc-locale-field">
                    <tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.DOC_NAME' | translate"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('title'))">
                        <tec-input
                            [formControl]="docLocaleControl('title', selectedDocLocaleId)"
                            [hasError]="reactiveFormService.hasError(docLocaleControl('title', selectedDocLocaleId))"
                        />
                    </tec-form-group>
                </div>
                <div id="modal-doc-locale-field-description" class="modal-doc-locale-field">
                    <tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.DESCRIPTION' | translate"
                        [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.DESCRIPTION_DESCRIPTION' | translate"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('description'))">
                        <tec-textarea
                            [formControl]="docLocaleControl('description', selectedDocLocaleId)"
                            [placeholder]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.DESCRIPTION_PLACEHOLDER' | translate"
                            [hasError]="reactiveFormService.hasError(docLocaleControl('description', selectedDocLocaleId))"
                        />
                    </tec-form-group>
                </div>
                <div id="modal-doc-locale-field-instructions" class="modal-doc-locale-field">
                    <tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.GUIDELINES' | translate"
                        [tooltip]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.GUIDELINES_DESCRIPTION' | translate"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('instructions'))">
                        <tec-textarea
                            [formControl]="docLocaleControl('instructions', selectedDocLocaleId)"
                            [placeholder]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.GUIDELINES_PLACEHOLDER' | translate"
                            [hasError]="
                                reactiveFormService.hasError(docLocaleControl('instructions', selectedDocLocaleId)) ||
                                reactiveFormService.hasError(form.get('instructions'))
                            "
                        />
                    </tec-form-group>
                </div>
                <!-- <tec-divider></tec-divider>
                <div class="grid grid-i2">
                    <tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_DOC_FORM.INSTRUCTIONS_PHOTO' | translate">
                        <tec-upload formControlName="instructions_photo" size="sm"></tec-upload>
                    </tec-form-group>
                </div> -->
            </tec-tile>
        }
    </ng-container>
</tec-modal>